// PageHeader — заголовок страницы с опциональным breadcrumb-слотом и action-кнопками.
import type { ReactNode } from 'react';
import { Box, Typography, Stack } from '@mui/material';

interface PageHeaderProps {
  /** Заголовок страницы. */
  title: string;
  /** Подзаголовок (опционально). */
  subtitle?: string;
  /** Слот для breadcrumbs (опционально). */
  breadcrumbs?: ReactNode;
  /** Слот для action-кнопок справа (опционально). */
  actions?: ReactNode;
}

/** Универсальный заголовок страницы в стиле MD3. */
export function PageHeader({ title, subtitle, breadcrumbs, actions }: PageHeaderProps): JSX.Element {
  return (
    <Box sx={{ mb: 3 }}>
      {breadcrumbs ? (
        <Box sx={{ mb: 1, color: 'text.secondary', fontSize: '0.875rem' }}>{breadcrumbs}</Box>
      ) : null}
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ sm: 'center' }} justifyContent="space-between">
        <Box>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 500 }}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {subtitle}
            </Typography>
          ) : null}
        </Box>
        {actions ? (
          <Stack direction="row" spacing={1.5} flexShrink={0}>
            {actions}
          </Stack>
        ) : null}
      </Stack>
    </Box>
  );
}
